import './Radio.sass';

import React, { FC } from 'react';
import { RadioItemProps } from './Radio.interface';
import { IcRadioButton24 } from '$assets';
import { classNames as cn } from '$utils';

export const RadioItem: FC<RadioItemProps> = ({ active, disabled }) => {
  return (
    <div className={cn('RadioItem', { disabled })}>{active && <IcRadioButton24 />}</div>
  );
};
